/**
 * <RevokeConfirmModal> — wraps `<ConfirmModal>` for the share-revoke flow.
 *
 * `external-sharing` Phase 3 Session 3.3 (2026-05-09).
 *
 * Owner-driven revoke. The mutation itself (optimistic flip + rollback +
 * settled invalidate) lives in `useRevokeShare()`. This component is a thin
 * confirm-dialog wrapper that surfaces the irreversibility + the
 * fork-survives-revoke invariant from spec §4 in copy.
 */
import { ConfirmModal } from '@/components/ui/ConfirmModal';

export interface RevokeConfirmModalProps {
  open: boolean;
  recipientLabel: string;
  onClose: () => void;
  onConfirm: () => void;
}

export function RevokeConfirmModal({
  open,
  recipientLabel,
  onClose,
  onConfirm,
}: RevokeConfirmModalProps) {
  return (
    <ConfirmModal
      open={open}
      onClose={onClose}
      onConfirm={onConfirm}
      title="Revoke this share?"
      confirmLabel="Revoke"
      danger
    >
      <p data-testid="revoke-confirm-body" className="leading-relaxed">
        <span className="text-text-bright">{recipientLabel}</span> will get a 404
        on next access. Existing forks of this share remain usable.
      </p>
      <p className="text-xs text-text-muted font-mono mt-3">
        This action cannot be undone.
      </p>
    </ConfirmModal>
  );
}
